module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAABHNCSVQICAgIfAhkiAAAAS1JREFUeF7t2dERwiAQRdHQmVamVqadRSwgrOMbx2BOvsMM3Nx9hKUtniGBhs+YAECFIQABlIUIgxjEoIwAgzJ+MohBDMoIMCjjJ4MYNLFB67qe+vTvxRLOrbVHtszPR/+0xAAqPhxAAH1e26+RDGIQgzICDMr4ySAGMSgjcHSDeoZcKoL9HHXbeufvM6gvcH0D0OZ5D6BOrxsE0MgigKqOHIPGhBjEoG0CdrH6R882P2LEIAYt0a0GgyYwqH+ka5/m8Ew4+tUoj0rVC3vPIICWZXizChBA2d08gxjEoK82zJSYElNiSuyXPWkZJINkkAySQRsE9tAwE9Izh3TSbJtlbNSTnmWRyTwBqm6GE7pHGMsgBmWeM4hBDMoIMCjjJ4MYxKCMAIMyfjKo4PcELqCSWDEUpz4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/a2.png
// module id = Ra2j
// module chunks = 1